// @ts-check
import React from 'react'
import { time as uniqId } from 'uniqid'
import isEmpty from 'ramda/src/isEmpty'
import map from 'ramda/src/map'
import { Label } from '../../Label/Label'
import { InfoIcon } from '../../InfoIcon/InfoIcon'
import styles from './style.css'

/**
 * @param {OptionProps} props
 */
const Option = ({ value, label, disabled }) => (
  <option value={value} disabled={disabled}>
    {label}
  </option>
)

/**
 * @param {{
 * placeholder?: string,
 * value: string,
 * label?: string,
 * onChange?: {(event: React.ChangeEvent): void},
 * disabled?: boolean,
 * required?: boolean,
 * name?: string,
 * options: OptionProps[],
 * error?: string,
 * valid: boolean,
 * info?: string,
 * showLabelAsPlaceholder?: boolean
 * className?: string
 * }} props
 */
const DefaultSelect = ({
  placeholder,
  label,
  name,
  disabled,
  required,
  onChange,
  options,
  error,
  value,
  valid,
  info,
  showLabelAsPlaceholder
}) => {
  /**
   * @type {string}
   */
  const htmlFor = uniqId()
  const className = !isEmpty(error) ? styles.invalid : ''

  return (
    <div className={`${styles.field} ${styles.block}`}>
      <div className={styles.inputBlock}>
        {!showLabelAsPlaceholder && (
          <Label htmlFor={htmlFor} value={label} valid={valid} info={info} />
        )}
        <select
          name={name}
          className={`${styles.select} ${className}`}
          id={htmlFor}
          disabled={disabled}
          onChange={onChange}
          required={required}
          value={value}
          autoComplete='nope'
        >
          {!isEmpty(placeholder) ? <option>{placeholder}</option> : null}
          {map(option => <Option key={uniqId()} {...option} selected={value === option.value} />)(
            options
          )}
        </select>
      </div>
      {showLabelAsPlaceholder && info && (
        <div className={styles.info}>
          <InfoIcon text={info} />
        </div>
      )}
    </div>
  )
}

Option.defaultProps = { disabled: false }

DefaultSelect.defaultProps = {
  label: 'Choose...',
  placeholder: '',
  name: 'select',
  disabled: false,
  required: true,
  onChange: () => {},
  options: []
}

export { DefaultSelect }
